import React, { Component, Fragment } from 'react';
import {PhotoSwipe} from 'react-photoswipe';

export default class CustomPhotoSwipe extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    this.setState({ isOpen: false });
  }

  render() {
    const { items, options, children } = this.props;
    const childrenWithProps = React.Children.map(children, child => React.cloneElement(child, {
      onClick: () => this.setState({ isOpen: true })
    }));
    return (
      <Fragment>
        { childrenWithProps }
        <PhotoSwipe
          isOpen={this.state.isOpen}
          items={items}
          options={options}
          onClose={this.handleClose}/>

      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CustomPhotoSwipe.js